import React from 'react';
import SvgIcon from '../SvgIcon';

export default function ArrowDownIcon(props) {
    return (
        <SvgIcon {...props}>
            {
                props.title !== null ? <title>NPG-FONT_arrow-down</title> : null
            }
            <path d="M28.83,10.69,16.72,22.8a1.46,1.46,0,0,1-1.13.48,1.62,1.62,0,0,1-1.13-.48L2.36,10.69a1.6,1.6,0,0,1,0-2.3,1.6,1.6,0,0,1,2.3,0l11,10.94L26.57,8.39a1.64,1.64,0,0,1,2.79,1.13A1.65,1.65,0,0,1,28.83,10.69Z" />
        </SvgIcon>
    );
}
